// extracted by mini-css-extract-plugin
module.exports = {"card":"Card-Card-module--card--19yYM responsive-module--text-align-left--2SgBH"};